import { VictoryContainer, VictoryPie } from 'victory';

import Bit from './Bit';
import styles from './GraphBit.style';

function adjust(color, amount) {
  return (
    '#' +
    color
      .replace(/^#/, '')
      .replace(/../g, (color) =>
        (
          '0' +
          Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
        ).substr(-2),
      )
  );
}

const colorScale = (color, length) => {
  let result = [];
  let offset = parseInt(200 / length);
  for (let i = 0; i < length; i++) {
    result.push(adjust(color, i * offset - 50));
  }
  return result;
};

const GraphBit = ({ classes, color = '#4f65cc', slices, title, ...props }) => {
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const scaledColors = colorScale(color, slices.length);
  const highlightAdjustedColors = scaledColors.map((c, i) =>
    i !== highlightedIndex ? 'rgb(250, 251, 252)' : c,
  );

  return (
    <Bit {...props}>
      <Bit.Title>{title}</Bit.Title>
      <div
        className={classes.root}
        style={{ display: 'flex' }}
        onMouseLeave={() => {
          setHighlightedIndex(-1);
        }}>
        <div className={classes.sectionList}>
          {slices.map((slice, i) => (
            <div
              style={{
                opacity:
                  highlightedIndex === -1 || i === highlightedIndex ? 1 : 0.5,
              }}
              key={slice[1]}
              className={classes.keyLine}
              onMouseEnter={() => {
                setHighlightedIndex(i);
              }}>
              <div
                className={classes.keyDot}
                style={{
                  background: scaledColors[i],
                }}
              />
              {slice[0]}
              <span>{slice[1]}%</span>
            </div>
          ))}
        </div>

        <VictoryPie
          containerComponent={
            <VictoryContainer
              responsive={false}
              className={classes.graphContainer}
            />
          }
          className={classes.graph}
          padding={0}
          height={180}
          width={180}
          events={[
            {
              eventHandlers: {
                onMouseOver: (event, { index }) => {
                  if (index !== 'parent') setHighlightedIndex(index);
                },
              },
            },
          ]}
          colorScale={
            highlightedIndex === -1 ? scaledColors : highlightAdjustedColors
          }
          labels={() => null}
          data={slices.map(([x, y]) => ({
            x,
            y,
          }))}
        />
      </div>
    </Bit>
  );
};

GraphBit.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  color: PropTypes.string,
  slices: PropTypes.array,
  title: PropTypes.string,
};

export default withStyles(styles)(GraphBit);
